import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/responsesForPdf']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getQuestionnaireResponsesForPdf = async ({
  page,
  perPage,
  questionnaireId,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/responsesForPdf', { questionnaireId });
  const data = await formsBackendClient.get(path, {
    params: { forPdfFills: true, page, perPage },
  });
  return data.data;
};

export default getQuestionnaireResponsesForPdf;
